import useDefinedContext from "hooks/useDefinedContext";
import OneRepMaxChartLinesContext from "../contexts/OneRepMaxChartLinesContext";

function useOneRepMaxChartLines() {
  return useDefinedContext(OneRepMaxChartLinesContext);
}

export default useOneRepMaxChartLines;
